import { WSEmptyState } from "@wingspanhq/fe-component-library";
import { useEffect } from "react";
import { sendMessageToParent } from "../../utils/postMessage";

const WALLET_NOT_FOUND_MESSAGE =
  "Set up Wingspan Wallet to get a free debit card";

export const EmbeddedWalletNotFound: React.FC = () => {
  useEffect(() => {
    sendMessageToParent("error", {
      code: "wallet_not_found",
      message: WALLET_NOT_FOUND_MESSAGE
    });
  }, []);

  return <WSEmptyState type="wallet" title={WALLET_NOT_FOUND_MESSAGE} />;
};
